import React from 'react'
import { Card, Form, Input, Button, Typography } from 'antd'
import { useLocation, useHistory } from 'react-router-dom'
import { UserOutlined, LockOutlined } from '@ant-design/icons'

import { openNotification } from '../functions'
import { useAuth } from '../authContext'

const { Title } = Typography

export default function Login() {
  const [loading, setLoading] = React.useState(false)
  const location = useLocation()
  const history = useHistory()
  const auth = useAuth()

  const login = values => {
    setLoading(true)
    auth.signin(values, loginSuccess, loginError)
  }

  const { from } = location.state || { from: { pathname: "/" } }
  const loginSuccess = () => {
    setLoading(false)
    history.replace(from)
  }

  const loginError = error => {
    setLoading(false)
    openNotification(
      'error',
      'Login',
      error.message
    )
  }

  return (
    <div className="loginc">
      <Card className="loginp">
        <div className="login-logo">
          <img src={process.env.PUBLIC_URL + '/logo.svg'} />
        </div>
        <Title level={2}>Login</Title>
        <Form
          name="login"
          initialValues={{ email: '', password: '' }}
          onFinish={login}>
          <Form.Item
            label=""
            name="email"
            rules={[
              { type: 'email', message: 'Por favor ingresa una dirección de correo electrónico.' },
              { max: 42, message: 'Superaste el limite de caracteres para este campo.' },
              { required: true, message: 'Este campo es requerido.' },
            ]}
            validateTrigger="onBlur">
            <Input size="large" placeholder="Usuario" addonBefore={<UserOutlined style={{ fontSize: 24 }} />} />
          </Form.Item>
          <Form.Item
            label=""
            name="password"
            rules={[
              { max: 20, message: 'Superaste el limite de caracteres para este campo.' },
              { required: true, message: 'Este campo es requerido.' },
            ]}>
            <Input.Password size="large" placeholder="Contraseña" addonBefore={<LockOutlined style={{ fontSize: 24 }} />} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" className="login-btn" htmlType="submit" loading={loading}>
              INGRESAR
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  )
}